let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jtFyt")).then(() => parcelRequire('af8K3'));